import Furniture from './Furniture';
import Heart from 'app/campout/Heart';

const STATE_IDLE = 1;
const STATE_TWEET = 2;
const STATE_WORM = 3;
const STATE_AWAY = 4;
const STATE_BACK = 5;

export default class Composter extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.state = STATE_IDLE;

    this.bb = new Phaser.Rectangle();
    this.dropArea = new Phaser.Rectangle(
      this.data.drop_area.x,
      this.data.drop_area.y,
      this.data.drop_area.w,
      this.data.drop_area.h
    );

    // container to store compostable items
    this.container = this.game.make.group();
    this.container.y = -215;
    this.addChildAt(this.container, 0);

    // composter back
    this.back = this.game.make.image(0, -25, 'furnitures', 'composter_back');
    this.back.anchor.set(0.5, 1);
    this.addChildAt(this.back, 0);

    //
    this.asset.setMixByName('idle', 'tweet', 0.2);
    this.asset.setMixByName('idle', 'action', 0.2);
    this.asset.setMixByName('tweet', 'action', 0.2);
    this.asset.setMixByName('idle', 'fly_away', 0.2);
    this.asset.setMixByName('fly_back', 'idle', 0.2);

    //
    this.asset.onEvent.add(this.handleAudioEvent, this);

    //
    this.setAnim('idle');
  }

  updateBounds() {
    this.bb.x = this.worldPosition.x + this.data.bounding_box.x;
    this.bb.y = this.worldPosition.y + this.data.bounding_box.y;
    this.bb.width = this.data.bounding_box.w;
    this.bb.height = this.data.bounding_box.h;
  }

  //
  setNight() {
    if (this.state === STATE_IDLE) {
      this.state = STATE_AWAY;
      this.setAnim('fly_away', false);
    }
  }

  setDay() {
    if (this.state === STATE_AWAY) {
      this.state = STATE_BACK;
      this.setAnim('fly_back', false);
      this.asset.onComplete.addOnce(this.handelFlyBackEnd, this);
    }
  }

  setLight(power) {
    super.setLight(power);
    super.setLight2(power);
  }

  updateTint(tween, value, tweenData) {
    super.updateTint(tween, value, tweenData);

    this.back.tint = this.tintColor;
    this.container.tint = this.tintColor;
  }

  //
  canPutItemInto(item) {
    // slot is empty
    if (this.visible) {
      const bb1 = new Phaser.Rectangle(
        this.bb.x + this.dropArea.x,
        this.bb.y + this.dropArea.y,
        this.dropArea.width,
        this.dropArea.height
      );
      const bb2 = item.bb;
      if (Phaser.Rectangle.intersects(bb1, bb2)) {
        return true;
      }
    }

    return false;
  }

  putItemInto(item) {
    item.trashed = true;
    item.disable();
    item.x = 0;
    item.y = 0;
    this.container.addChild(item);

    // anim
    this.game.add
      .tween(item)
      .to({ y: 30, alpha: 0 }, 500, null, true, 300)
      .onComplete.add(this.handleSinkAnimEnd, this);

    //
    this.game.sounds.stopAudioSprite('generic_down', { spriteID: 'sfx' });
    this.game.sounds.playSFX('item_compost', { spriteID: 'sfx' });

    //
    this.location.state.setLoopHint(this.data.hint);
  }

  handleSinkAnimEnd(target) {
    this.location.removeItem(target);

    if (this.state !== STATE_WORM && this.location.isDay()) {
      this.state = STATE_WORM;

      this.asset.onComplete.addOnce(this.handelWormAnimEnd, this);
      this.setAnim('action', false);
    }
  }

  handelWormAnimEnd() {
    if (this.location.isDay()) {
      // day
      this.state = STATE_BACK;
      this.setAnim('fly_back', false);
      this.asset.onComplete.addOnce(this.handelFlyBackEnd, this);
    } else {
      // night
      this.state = STATE_AWAY;
    }
  }

  handelFlyBackEnd() {
    if (this.location.isDay()) {
      this.state = STATE_IDLE;
      this.setAnim('idle');
    } else {
      this.state = STATE_AWAY;
      this.setAnim('fly_away', false);
    }
  }

  handleInputDown() {
    if (this.state === STATE_IDLE) {
      this.state = STATE_TWEET;

      this.asset.onComplete.addOnce(this.handelTweetAnimEnd, this);
      this.setAnim('tweet', false);

      this.game.sounds.playSFX('item_robin', { spriteID: 'sfx' });
    }
  }

  handelTweetAnimEnd() {
    this.handelFlyBackEnd();
  }

  handleAudioEvent(track, event) {
    track;
    this.game.sounds.playSFX(event.data.name, { spriteID: 'sfx' });

    if (event.data.name === 'item_eatworm') {
      const heart = new Heart(this.game, 20, -220);
      this.addChild(heart);
    }
  }

  pulse(time = 1500) {
    this.game.add
      .tween(this.back.scale)
      .to({ x: [1.1, 1, 1.1, 1, 1.1, 1], y: [1.1, 1, 1.1, 1, 1.1, 1] }, time, null, true);

    this.game.add
      .tween(this.rootBone)
      .to({ scaleX: [1.1, 1, 1.1, 1, 1.1, 1], scaleY: [1.1, 1, 1.1, 1, 1.1, 1] }, time, null, true);
  }
}
